export default __webpack_public_path__ + "static/media/section3-bg2.0ce51326.png";